/**
 * Utility functions for phone number formatting
 */

/**
 * Formats a phone number to (XXX)-XXX-XXXX format
 * @param value - The phone number string (can be digits only or already formatted)
 * @returns Formatted phone number string
 */
export const formatPhoneNumber = (value: string | null | undefined): string => {
    if (!value) return '';

    // Remove all non-digit characters
    const digits = value.replace(/\D/g, '');

    // If empty after removing non-digits, return empty string
    if (!digits) return '';

    // Limit to 10 digits
    const limitedDigits = digits.slice(0, 10);

    // Apply formatting
    if (limitedDigits.length <= 3) {
        return limitedDigits;
    } else if (limitedDigits.length <= 6) {
        return `(${limitedDigits.slice(0, 3)})-${limitedDigits.slice(3)}`;
    } else {
        return `(${limitedDigits.slice(0, 3)})-${limitedDigits.slice(3, 6)}-${limitedDigits.slice(6)}`;
    }
};

/**
 * Formats a phone number for display (always returns formatted or empty)
 * @param value - The phone number string
 * @returns Formatted phone number or empty string
 */
export const displayPhoneNumber = (value: string | null | undefined): string => {
    const formatted = formatPhoneNumber(value);
    return formatted || '';
};
